module.exports = __webpack_public_path__ + "img/141.4.7a17c19f.png";